import type { Loader } from "@storybook/react"

import { setVariantOverrides } from "../helpers/setVariantOverrides"

export const featureFlagsLoader: Loader = async context => {
  // Support feature flags defined in the story parameters and/or globals
  const globalsFeatureFlags = context.globals.featureFlags || {}
  const parametersFeatureFlags = context.parameters.featureFlags || {}

  const variants = {
    ...parametersFeatureFlags,
    ...globalsFeatureFlags,
  }

  setVariantOverrides({ variants })
}
